import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'

import { useTemplate } from 'modules/processes/hooks/useTemplate'

import { detailsStep } from './DetailsStep'
import { previewStep } from './PreviewStep'
import { WizardData } from './types'

type Props = {
  templateId: string
  onSuccess: (processId: string) => void
  onClose: () => void
}

const ProcessFromTemplateWizard = ({ templateId, onSuccess, onClose }: Props) => {
  const { template, error, loading: loadingTemplate } = useTemplate(templateId)

  const steps: WizardStep<WizardData>[] = [previewStep(), detailsStep()]

  if (error) throw new Error(`Error loading template: ${error}`)

  if (!template || loadingTemplate)
    return <Wizard.LoadingModal onClose={onClose}></Wizard.LoadingModal>

  return (
    <>
      <Wizard.Modal
        title={template.name}
        description={template.description ?? undefined}
        steps={steps}
        initialData={{
          template,
        }}
        onSubmit={(data) => {
          if (!data.processId) return

          onSuccess(data.processId)
        }}
        onClose={onClose}
      />
    </>
  )
}

export default ProcessFromTemplateWizard
